import React from "react";
import "./footer.css";
import { MdEmail, MdWifiCalling3 } from "react-icons/md";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FooterLogo from "./../../../assets/images/footerLogo.png";
import { Button } from "@mui/material";
import GooglePlayLogo from "./../../../assets/images/googlePlay.png";
import AppStoreLogo from "./../../../assets/images/appStore.png";
let Footer = () => {
  return (
    <div className="footer-container">
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div>
              <img src={FooterLogo} alt="Logo" className="footer-logo" />
              <p className="footer-description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Pellentesque fringilla velit sed diam vestibulum, quis finibus
                elit rutrum.
              </p>
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div>
              <h1 className="footer-heading">Quick link</h1>
              <Button className="footer-button" variant="text">
                home
              </Button>
              <Button className="footer-button" variant="text">
                cources
              </Button>
              <Button className="footer-button" variant="text">
                About us
              </Button>
              <Button className="footer-button" variant="text">
                Contact us
              </Button>
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div>
              <h1 className="footer-heading">Download app</h1>
              <Button className="footer-download-app-button" variant="text">
                <img
                  src={GooglePlayLogo}
                  alt="Google Play"
                  className="footer-download-app-image"
                />
              </Button>
              <Button className="footer-download-app-button" variant="text">
                <img
                  src={AppStoreLogo}
                  alt="App Store"
                  className="footer-download-app-image"
                />
              </Button>
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div>
              <h1 className="footer-heading">Contact us</h1>
              <div className="footer-email-main">
                <MdEmail color="#fff" size={24} />
                <p className="footer-contact-data">Support@amafclasses.com</p>
              </div>
              <div className="footer-mobile-number">
                <MdWifiCalling3 color="#fff" size={24} />
                <p className="footer-contact-data">+971 1 2345678</p>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
export default Footer;
